import src from "IMAGE";
export default { src, width: 1301, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AKysrGapqaplrKysZbOzs3GrrKxpqampYqmpqWGtra5dQp0TSYWCBZwAAAAASUVORK5CYII="};
